import { ActivityRoutes } from "./private/activity.routes";
import { AdminRoutes } from "./private/admin.routes";
import { AuditRoutes } from "./private/audit.routes";
import { CheckpointRoutes } from "./private/checkpoint.routes";
import { ComplianceAuditRoutes } from "./private/compliance.audit.routes";
import { DashboardRoutes } from "./private/dashboard.routes";
import { EntityMappingRoutes } from "./private/entitymapping.routes";
import { InternalComplianceRoutes } from "./private/internal_complaince.routes";
import { ListManagementRoutes } from "./private/listmanagement.routes";
import { LocationRoutes } from "./private/location.routes";
import { ManageAuditRoutes } from "./private/manage_audit.routes";
import { ReportRoutes } from "./private/reports.routes";
import { RepositoryRoutes } from "./private/repository.routes";
import { ShowCauseNoticeRoutes } from "./private/showcausenotice.routes";
import { SupportRoutes } from "./private/support.routes";
import { TaskRoutes } from "./private/task.routes";
import { UnusedRoutes } from "./private/unused.routes";
import { VendorRoutes } from "./private/vendors.routes";

export const PrivateRoutes = [
	...AdminRoutes,
	...CheckpointRoutes,
	...DashboardRoutes,
	...ListManagementRoutes,
	...LocationRoutes,
	...TaskRoutes,
	...VendorRoutes,
	...UnusedRoutes,
	...ReportRoutes,
	...EntityMappingRoutes,
	...AuditRoutes,
	...ActivityRoutes,
	...RepositoryRoutes,
	...ComplianceAuditRoutes,
	...ShowCauseNoticeRoutes,
	...SupportRoutes,
	...ManageAuditRoutes,
	...InternalComplianceRoutes
];
